import * as React from 'react';
export const TranslationsContext = React.createContext({
    translations: {},
    translate: (key) => key,
    translateGlobal: (key) => key,
    translateApp: (app, key) => `${app}:${key}`,
    translateOrEmpty: () => ''
});
TranslationsContext.displayName = 'TranslationsContext';
